import initializeRenderCanvas from "./initializeRenderCanvas";
import resize from "./resize";
import storedColorPixelDataToCanvasImageData from "./storedColorPixelDataToCanvasImageData";
import storedPixelDataToCanvasImageData from "./storedPixelDataToCanvasImageData";
import storedPixelDataToCanvasImageDataColorLUT from "./storedPixelDataToCanvasImageDataColorLUT";
import storedPixelDataToCanvasImageDataRGBA from "./storedPixelDataToCanvasImageDataRGBA";
import storedRGBAPixelDataToCanvasImageData from "./storedRGBAPixelDataToCanvasImageData";

const Canvas = {
  initializeRenderCanvas,
  resize,
  storedColorPixelDataToCanvasImageData,
  storedPixelDataToCanvasImageData,
  storedPixelDataToCanvasImageDataColorLUT,
  storedPixelDataToCanvasImageDataRGBA,
  storedRGBAPixelDataToCanvasImageData
};

export default Canvas;
